import React from 'react'
import { ProgressBarComponent } from '@syncfusion/ej2-react-progressbar'
import '../DashboardStyle.css'
import { DashboardUnit } from '@dataTypes/dashboard.types'

type ProgressBarProps = {
  title: string
  currentValue: number
  maxValue?: number
  minValue?: number
  unit: DashboardUnit
}

function ProgressBarLinear({
  title,
  currentValue,
  maxValue,
  minValue,
  unit,
}: ProgressBarProps): React.ReactElement {
  // render the annotation content
  const content = `<div id="point1" style="font-size:1.85rem;font-weight:semi-bold;color:#000000;"><span>${unit === 'percent' ? `${currentValue}%` : `$${currentValue}`}</span></div>`

  return (
    <div className="dashboard-control-pane" key={title}>
      <div className="dashboard-control-section">
        <ProgressBarComponent
          id={title}
          type="Linear"
          width="100%"
          trackThickness={15}
          progressThickness={15}
          value={currentValue}
          minimum={minValue ?? 0}
          maximum={maxValue ?? 100}
          cornerRadius={'Round'}
        ></ProgressBarComponent>
      </div>
    </div>
  )
}

export default ProgressBarLinear
